export default "__VITE_ASSET__8a2d2e65__"